var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c(
    "div",
    {
      staticClass: "zj-flex-column",
      staticStyle: { width: "100%", position: "relative" },
    },
    [
      _c("mainPage", {
        directives: [
          {
            name: "show",
            rawName: "v-show",
            value: _vm.mainPageName == "mainPage",
            expression: "mainPageName =='mainPage'",
          },
        ],
        ref: "mainPage",
        staticClass: "zj-flex-column",
      }),
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }